export default __webpack_public_path__ + "static/media/discord-color.f4786b48.svg";